import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-grid_icon",
  "use": "icon-grid_icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-grid_icon\">\n<rect x=\"0.5\" y=\"0.5\" width=\"9\" height=\"9\" rx=\"2\" fill=\"#67788C\" />\n<rect x=\"11\" y=\"1\" width=\"8\" height=\"8\" rx=\"1.5\" fill=\"white\" stroke=\"#67788C\" />\n<rect x=\"1\" y=\"11\" width=\"8\" height=\"8\" rx=\"1.5\" fill=\"white\" stroke=\"#67788C\" />\n<rect x=\"10.5\" y=\"10.5\" width=\"9\" height=\"9\" rx=\"2\" fill=\"#67788C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/grid_icon.svg
// module id = Y7a6
// module chunks = 258